import React, { FC } from 'react';
import { DiscountStructureType } from '../../../models/discount-structure-type';
import DiscountStructureTable from '../../molecules/discount-structure-table/discount-structure-table';

const DiscountStructure: FC<DiscountStructureType> = (
  props: DiscountStructureType
) => {
  const { labels } = props;

  return (
    <div className="py-component-spacing-mobile md:py-component-spacing mx-auto lg:ml-20">
      <h4 className="page-heading-four mb-6 md:mb-8">{labels.title}</h4>

      <hr className="block md:hidden border-grey-100 mb-6" />

      <DiscountStructureTable {...props} />
    </div>
  );
};

export default DiscountStructure;
